import { Multiselect, MultiselectProps } from '@amzn/awsui-components-react';
import {
  OptionDefinition,
  OptionGroup,
} from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { NonCancelableEventHandler } from '@amzn/awsui-components-react/polaris/internal/events';
import * as React from 'react';
import styles from './MultiSelectInput.module.scss';

interface MultiSelectInputProps {
  label: string;
  selectedOptions: OptionDefinition[];
  placeholder: string;
  options: (OptionDefinition | OptionGroup)[];
  onChange: NonCancelableEventHandler<MultiselectProps.MultiselectChangeDetail>;
}

/**
 *
 * @param param0 Takes in a label, selectedOptions, a placeholder, and selectable options
 * @returns A Polaris dropdown component aligned with ConsoleUI needs
 */
export const MultiSelectInput: React.FC<MultiSelectInputProps> = ({
  label,
  selectedOptions,
  placeholder,
  options,
  onChange,
}) => {
  return (
    <label className={styles.multiSelectContainer}>
      <span>{label}</span>
      <Multiselect selectedOptions={selectedOptions} placeholder={placeholder} options={options} onChange={onChange} />
    </label>
  );
};
